export var formatMarketCap = function(number) {
    return number ? "$".concat(Math.round(number).toLocaleString()) : null;
};
export var truncateString = function(word, number) {
    if (word.length <= number - 3) {
        return word;
    }
    return word.substring(0, number - Math.min(3, word.length - number)) + "...";
};
